import { Trans } from "react-i18next";
export default function showPlaceholderPageData(array: any) {
    const translationArray = Array.isArray(array) ? array : [];
    const showContent = translationArray.map((item, index) => (
        <div key={index}>
            <h4 className="text-start my-4 fw-bold border-2 border-bottom border-warning pb-3 ps-3"><Trans i18nKey={Object.keys(item)[0]}></Trans></h4>
            <p><Trans i18nKey={Object.values(item)[0] as string}></Trans></p>
        </div>
    ))
    return showContent
}